/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { Component } from 'react';
import {
    Route, Routes,
} from 'react-router-dom';

import EntityVerificationsContainer from "./EntityVerificationsContainer";

export default class EntityVerificationsRouter extends Component {
    static propTypes = {

    };

    static defaultProps = {

    };

    render() { // eslint-disable-line
        return (
            <Routes>
                <Route path="/" element={<EntityVerificationsContainer/>} />
            </Routes>
        );
    }
}
